import { lazy, useState } from 'react';
import { z } from 'zod';
import { useAuthStore } from '@/stores/auth';
import { PageFrame } from '@/components/executive/ExecAtoms';
import { DeskState, deskDate } from '../dashboard/roles/ProfileDeskParts';
import { useProfileResource } from '../dashboard/roles/useProfileResource';
const ActivitiesDualPage = lazy(() => import('../sales/ActivitiesDualPage').then(module => ({ default: module.ActivitiesDualPage })));
const parse = (body: unknown) => z.object({
  data: z.array(z.object({
    id: z.string(), type: z.string(), title: z.string().nullish(), description: z.string().nullish(), createdAt: z.string(),
    user: z.object({ firstName: z.string().nullish(), lastName: z.string().nullish() }).nullable(),
  })), pagination: z.object({ total: z.number(), totalPages: z.number() }),
}).parse(body);

/** CRM's existing Activities menu uses activity records, without sales KPIs. */
export function CrmActivitiesRoute() {
  const user = useAuthStore(s => s.user);
  return user?.role?.name === 'operations_manager'
    ? <CrmActivityRecords key={`${user.tenantId}:${user.id}`} /> : <ActivitiesDualPage />;
}
function CrmActivityRecords() {
  const [page, setPage] = useState(1);
  const resource = useProfileResource(`/activities?page=${page}&limit=50`, parse);
  return <PageFrame title="Activities" sub="Customer activity records" actions={<button onClick={resource.reload}>Refresh</button>}>
    <DeskState resource={resource} />
    {resource.data && <>
      <p className="mb-3">{resource.data.pagination.total} activities</p>
      <ul className="divide-y rounded border bg-white">{resource.data.data.map(row => <li className="p-4" key={row.id}>
        <h3 className="font-medium">{row.title || row.type}</h3>
        {row.description && <p className="whitespace-pre-wrap">{row.description}</p>}
        <p className="text-sm text-gray-500">{[row.user?.firstName, row.user?.lastName].filter(Boolean).join(' ') || 'User not recorded'} · {deskDate(row.createdAt)} · {row.type}</p>
      </li>)}</ul>
      {!resource.data.data.length && <p>No activity records.</p>}
      <div className="mt-4 flex gap-4"><button disabled={page === 1} onClick={() => setPage(p => p - 1)}>Previous</button><span>Page {page}</span><button disabled={page >= resource.data.pagination.totalPages} onClick={() => setPage(p => p + 1)}>Next</button></div>
    </>}
  </PageFrame>;
}
